<template>
  <div v-if="$storeUniversite.itemLang == 'lang00'">
    <h1 class="text-center" style="color: #d84a2b">Candidature soumise</h1>
    <h2 class="text-center" >Votre candidature a été soumise et sera traitée dans les plus brefs délais.</h2>
    <p class="text-center">
      Nous vous remercions de votre intérêt.
    </p>
  </div>
  <div v-else>
    <h1 class="text-center" style="color: #d84a2b" >Application Form Submitted</h1>
    <h2 class="text-center">Your application has been received and will be processed as soon as possible.</h2>
    <p class="text-center">
        Thank you for your interest.
    </p>
  </div>
</template>

<script>
export default {
  // Votre logique de composant si nécessaire
};
</script>

<style scoped>
/* Vos styles CSS spécifiques à ce composant si nécessaire */
</style>
